class HXList {

    listName = "";
    formName = "";
    colResizeTimeOutId = null;
    listVars = null;

    /**
     * @param {string|null} listName
     */
    constructor(listName = null) {
        this.listName = listName;
        this.formName = listName;

        const tmpVar = window["\$hxListVar"+this.listName];
        this.listVars = {
            root          : (tmpVar.hasOwnProperty("root")===true)           ? tmpVar.root : "",
            dictAskdelMsg : (tmpVar.hasOwnProperty("dictAskdelMsg")===true)  ? tmpVar.dictAskdelMsg : "",
        };

    }

    /**
     * @return {boolean}
     */
    isTouchDevice = function () {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0)); //IE and old Edge
    }

    /**
     * @param {int} id
     * @param {string} urlParam z.B "id_person=5&show=all"
     */
    rowDelete(id, urlParam) {
        const listForm = document.forms[this.formName];
        const $icondel = $(listForm).find(`[name='icondel${id}']`);
        const $orgColor = $icondel.css("color");

        $icondel.css("color","red");
        setTimeout(() => {
            if (confirm(this.listVars.dictAskdelMsg) === true) {
                if (urlParam !== '') {
                    if (listForm.action.indexOf('?') < 0) {
                        listForm.action+= '?' + urlParam;
                    } else {
                        listForm.action+= '&' + urlParam;
                    }
                }
                listForm.listScrollPosTop.value = $(document).scrollTop();
                listForm.listScrollPosLeft.value = $(document).scrollLeft();
                listForm.id_del.value = id;
                listForm.submit();
            } else {
                $icondel.css("color",$orgColor);
            }
        },100);

    }

    /**
     * Zeile markieren bzw. Markierung entfernen
     * @param {object} trObj
     */
    rowToggleHighlight = function (trObj) {
        $(trObj).toggleClass('hxlistrowhighlight');
    };


    /**
     *
     * @param {string} visibleColNumber
     * @param {string} colRowDelta
     * @param {string} colHeadDelta
     * @param {string} elem
     */
    colToggleMultiline(visibleColNumber, colRowDelta, colHeadDelta, elem) {
        var toggleMultilineElement = $("form[name='"+this.listName+"'] .hxlistrowhead td:nth-child("+(hx.cint(visibleColNumber)+hx.cint(colHeadDelta))+") > .toggleMultiline > i");
        var toggleStateClosed = true;

        //Spaltenkopf wurde geklickt
        let colObj;
        if (elem===null || elem===undefined) {
            colObj = $("form[name='"+this.listName+"'] .hxlistrow td:nth-child(" + (hx.cint(visibleColNumber)+hx.cint(colRowDelta)) + ")");
            if (toggleMultilineElement.hasClass("fa-reflect-vertical")) {
                toggleStateClosed = false;
                toggleMultilineElement.attr('class', 'fa-solid fa-sort');
            } else {
                toggleMultilineElement.attr('class', 'fa-solid fa-reflect-vertical');
            }
            //einzelne Zelle wurde geklickt
        } else {
            colObj = $(elem);
            if (colObj.hasClass('toggleMultilineOpen')) toggleStateClosed = false;
        }

        //Ganze Spalte umschalten
        if (toggleStateClosed===false) {
            colObj.removeClass('toggleMultilineOpen');
            colObj.addClass('toggleMultilineClosed');
        } else {
            colObj.removeClass('toggleMultilineClosed');
            colObj.addClass('toggleMultilineOpen');
        }

    }

    /**
     * @param {int} sort
     */
    colSort(sort) {
        const listForm = document.forms[this.formName];
        listForm.sort.value = sort;
        listForm.listScrollPosTop.value = $(document).scrollTop();
        listForm.listScrollPosLeft.value = $(document).scrollLeft();
        listForm.submit();
    }

    /**
     * @param {int} pageNr
     */
    pageGoto(pageNr) {
        const listForm = document.forms[this.formName];
        listForm.page.value = pageNr;
        listForm.submit();
    }

    /**
     * Die aktuellen Settings sollen zurueckgesetzt werden
     */
    settingsReset() {
        let moved;
        do {
            moved = false;
            $("form[name="+this.formName+"] .listsettings_ul").children().each(function (idx, elem) {
                let colNbr = $(elem).data("columnpos_default");
                let pevColNbr = $(elem).prev().data("columnpos_default");
                $(elem).find("input:checkbox").prop("checked", true);
                if (pevColNbr !== undefined && colNbr !== undefined && hx.cint(colNbr) < hx.cint(pevColNbr)) {
                    $(elem).insertBefore($(elem).prev());
                    moved = true;
                }
            });
        } while (moved);
    }

    /**
     * Die aktuellen Settings sollen gepeichert werden
     */
    settingsSave() {
        const listForm = document.forms[this.formName];
        listForm.listSettings.value = 1;
        listForm.submit(); //Formular absenden - Filter unveraendert lassen
    };

    /**
     * @param {int} action 1..do filter, -1..reset filter
     */
    filter(action) {
        const listForm = document.forms[this.formName];
        listForm.filter.value=action;
        listForm.page.value=1;
        listForm.listScrollPosTop.value = $(document).scrollTop();
        listForm.listScrollPosLeft.value = $(document).scrollLeft();
        if (document.activeElement && document.activeElement.name) listForm.listActiveElement.value = document.activeElement.name;
        listForm.submit();
    }

    /**
     * Spaltenbreite aendern: Breite in Session speichern
     * @param {Element} elem
     */

    filterResizeSave(elem) {
        let width    = hx.cint(elem.style.width);
        let minWidth = hx.cint(elem.style.minWidth);
        let colIndex = elem.getAttribute("data-index");

        if (hx.cint(width)>0 && hx.cint(minWidth)>0 && colIndex.length>0 && this.listName.length>0) {
            if (width <= minWidth) { //Mindestbreite einhalten - resize Event liefert leider breite bei der Maus losgelassen wurde
                width = null; //Defaultbreite 
            }

            $.ajax({
                url: $hxVar.root+'libhx/ajax/hxlist/ajax_hxlist.php',
                type: "POST",
                async: true,
                data:{
                    listname:this.listName,
                    colindex:colIndex,
                    colwidth:width}
            });
        }
    }

    /**
     * @param {Element} select
     * @param {Boolean} display
     */
    filterMultiSelectOptionsDisplay(select,display=true) {
        let obj = document.getElementById(select.name + '_options');

        if (display) {
            obj.style.display = '';
            obj.style.top = '0px';
            obj.style.left = '0px';
            obj.focus();
        } else {
            let multiselectHidden = $("#" + select.name + "_hidden");
            let oldval = multiselectHidden.val();
            this.filterMultiSelectTextUpdate(select.name);
            //beim verlassen sofort filtern - wenn Filteraenderungen erfolgt sind
            if ((this.isTouchDevice() || obj.getAttribute('data-filteronchange') === '1') && oldval + '' !== ''+multiselectHidden.val()) {
                new HXList(this.listName).filter(1);
            }
            let oldDisplay = obj.style.display;
            obj.style.display = 'none';
            //Aktuelles li.active wird nicht entfernt, damit beim wieder oeffnen des Multiselects dort wieder fortgesetzt werden kann

            //Focus auf Select-Element setzen, damit danach mit "Enter" Filterung ausgel�st werden kann
            //oldDisplay: Klick ausserhalb vom Multiselect schliesst alle ->  Focus nur auf jenes setzten, dass zuvor offen war - Browser scrollt autom. zum Feld
            if (oldDisplay==='') {
                $(select).trigger("focus");
            }
        }
    }

    /**
     * MultiselectFilter: Anzeigetext und hidden-Element aktualisieren
     * @param {string} fieldName
     */
    filterMultiSelectTextUpdate(fieldName) {
        let str = "";
        let checkedCount = 0;
        let field_hidden = document[this.formName][fieldName + '_hidden']; //hidden-Element des MuliSelectFilters
        let field = document[this.formName][fieldName]; //select-Element des MuliSelectFilters

        field_hidden.value = "";
        $("#" + fieldName + "_options input:checkbox").each((idx, elem) => {
            if (elem.checked) {
                str += ', ' + hx.strip_tags(elem.parentNode.innerHTML);
                checkedCount++;
                if (idx > 0) field_hidden.value += elem.value + ",";
            }
        });
        field_hidden.value = hx.trim(field_hidden.value, ", ");
        field.title = hx.trim(str, ', ');

        if (checkedCount === 1) {
            field[0].innerHTML = hx.trim(str, ', ');
        } else {
            field[0].innerHTML = "&#9745; "+checkedCount;
        }
    }


    /**
     * @param {Element} select
     */
    filterMultiSelectEventsInit(select) {
        let obj = document.getElementById(select.name + '_options');

        //Ausserhalb div.multiselect_options klicken - dieses schliessen
        $(document).on("mousedown", (event) => {
            this.filterMultiSelectOptionsDisplay(select,false);
        });

        //div.multiselect_options schliessen verhindern beim Anklicken
        $(obj).on("mousedown", (event) => {
            event.stopPropagation();
        });

        //div.multiselect_options schliessen beim Klicken auf Close-Icon
        //Gleichzeitig Filtern ausloesen, wenn dies die Einstellung so wuenscht
        //Auf Touchgeraeten immer Filtern ausloesen (Grund: Es wird auf Touch-Geraeten keine Tastatur eingeblendet)
        $(obj).find(".close").on("click",(event) => {
            event.stopPropagation(); //Event auf darunterliegendes li nicht weitergeben
            this.filterMultiSelectOptionsDisplay(select,false);
        });

        //Scrollen mit Tasten verhindern
        $(obj).on("keydown", (event) => {
            if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === " ") {
                event.preventDefault();
                return false;
            }
        });

        //div.multiselect_options mit Tasten durchnavigieren
        $(obj).on("keyup", (event) => {
            var $optActive = $(obj).find("li.active");

            //Escape, Enter, Tab: Multiselect schliessen
            if (event.key === "Enter" || event.key === "Escape" || event.key === "Tab") {
                this.filterMultiSelectOptionsDisplay(select,false);

            //ArrowDown: Naechste Option auswaehlen
            } else if (event.key === "ArrowDown") {
                if ($optActive.length===0) {
                    $(obj).find("li").first().addClass("active");
                } else {
                    if (!$optActive.is(':last-child') && $optActive.next()) {
                        $optActive.removeClass("active");
                        $optActive.next().addClass("active");
                    }
                }
            //ArrowUp: Vorherige Option auswaehlen
            } else if (event.key === "ArrowUp") {
                if ($optActive.length===0) {
                    $(obj).find("li").first().addClass("active");
                } else {
                    if (!$optActive.is(':first-child') && $optActive.prev()) {
                        $optActive.removeClass("active");
                        $optActive.prev().addClass("active");
                    }
                }
            //Space: Option auswaehlen
            } else if (event.key === " ") {
                if ($optActive.length) $optActive.trigger("click");
            }

            if ($optActive.length) {
                var t = $optActive[0]; //native DOM-Element
                var p = t.parentNode.parentNode;
                var grenzeOben = p.scrollTop;
                var grenzeUnten = p.offsetHeight + p.scrollTop;

                if ((t.offsetTop - t.offsetHeight) < grenzeOben && event.key === "ArrowUp") {
                    p.scrollTop = t.offsetTop - t.offsetHeight;
                } else if ((t.offsetTop + t.offsetHeight * 2) > grenzeUnten && event.key === "ArrowDown") {
                    p.scrollTop = t.offsetTop + t.offsetHeight * 2 - p.offsetHeight;
                }
            }
            event.preventDefault();
            return false;
        });


        // Option Checkbox-Text Click Handling
        $(obj).find('li').on("click", (event) => {
            $(event.target.getElementsByTagName('input')[0]).trigger("click");
        });

        // Option Checkbox click Handling
        $(obj).find('input').on("click", (event) => {

            $(obj).find('li').removeClass("active");
            $(event.currentTarget.parentNode).addClass("active");

            if ($(event.currentTarget).hasClass("asterisk")) {
                if (event.currentTarget.checked) {
                    $(obj).find("input:not(.asterisk)").prop("checked", false);
                } else {
                    $(obj).find("input:not(.asterisk)").prop("checked", true);
                }
            } else {
                if (event.currentTarget.checked) {
                    $(obj).find("input.asterisk").prop("checked", false);
                } else {
                    if ($(obj).find("input:checked").length===0) {
                        $(obj).find("input.asterisk").prop("checked", true);
                    }
                }
            }
            event.stopPropagation(); //Click nicht an <li> weitergeben
        });
    }

    /**
     *
     * @param {string} activeElemName
     * @param {int} scrollPosLeft
     * @param {int} scrollPosTop
     */
    displayInit(activeElemName,scrollPosLeft,scrollPosTop) {

        var $listForm = $("form[name='"+this.listName+"']");

        //Focus auf Filterfeld setzten
        if (document.forms[this.formName].elements[activeElemName]) document.forms[this.formName].elements[activeElemName].focus();
        //Scrollbars auf vorherige Position setzen
        if (hx.cint(scrollPosTop)>0 || hx.cint(scrollPosLeft)>0) window.scrollTo(scrollPosLeft,scrollPosTop);

        //Filtern mit Enter ausloesen wenn Focus auf Filterfeld steht - hxfimultiselect hat eigenen Event Handler
        $listForm.find(".hxfitext, .hxfinumber, .hxfibooleanselect, .hxfiselect, .hxfidate,.hxfimultiselect").on("keypress", (event) => {
            if (event.key === "Enter") new HXList(this.listName).filter(1);
        });

        //Auf Touchgeraeten nach dem auswaehlen von Select-Filtern das Filtern ausloesen (Grund: Es wird auf Touch-Geraeten keine Tastatur eingeblendet)
        $listForm.find(".hxfiselect, .hxfibooleanselect").on("change", (event) => {
            if (this.isTouchDevice()) new HXList(this.listName).filter(1);
        });

        //MultiselectFilter oeffnen
        $listForm.find(".hxfimultiselect").on("mousedown",  (event) =>  {
            this.filterMultiSelectOptionsDisplay(event.currentTarget,true);
            event.preventDefault();
            event.stopPropagation(); //Verhindert sofortiges schliessen durch ausserhalb div.multiselect_options klicken
            return false;
        })

        $listForm.find(".hxfimultiselect").on("keydown",  (event) =>  {
            if (event.key===" " || event.key==="ArrowDown") {
                this.filterMultiSelectOptionsDisplay(event.currentTarget,true);
                event.preventDefault();
                return false;
            }
        });

        //MultiselectFilter initialisieren
        $listForm.find(".hxfimultiselect").each((idx,elem) => {
            this.filterMultiSelectTextUpdate($(elem).attr("name")); //Alle Multiselect-Filter: angezeigten Text aktualisieren
            this.filterMultiSelectEventsInit(elem); //Events der MultiselectFilter einh�ngen
        });


        //Zellen-Tooltips dynamisch erzeugen wenn textbreite groesser spaltenbreite
        $listForm.find(".hxlistrow td:not(.listcelldeletebtn)").on("mouseenter", function (event) {
            let $elem = $(event.currentTarget); //jquery Objekt um jquery-lookups zu reduzieren
            if (!$elem.length || $elem.attr("autotitle")==='no') return;

            let tdWidth = $elem.width();

            let $tooltipObject = $("<span>", {
                style: "visibility:hidden; white-space:nowrap; position:absolute;",
                text: $elem.text()
            }).appendTo("body");

            let textWidth = $tooltipObject.width();
            $tooltipObject.remove();

            //Anzeigen/Entfernen des title Attributes
            if (textWidth > tdWidth) {
                $elem.attr("title", $elem.text());
            } else {
                $elem.removeAttr("title");
            }
        });



        //Zeilenmarkierung via Mausklick on/off
        $listForm.find(".hxlistrow").on("click", (event) => {
            this.rowToggleHighlight($(event.currentTarget).get(0));
        });

        //toggleMultiline je Spalte initialisieren - Alle Spalten (listcolumnheadline) durchgehen
        $listForm.find('.hxlistrowhead td.listcolumnheadline').each((idx,elem) => {
            let $elem = $(elem); // Cache the jQuery object
            let $toggleIcon = $elem.children('.toggleMultiline');

            if ($elem.children('.toggleMultiline').length) {
                let colRowDelta = $toggleIcon.attr("data-togglemultiline-colrowdelta");
                let colHeadDelta = $toggleIcon.attr("data-togglemultiline-colheaddelta");
                let rowCell = $("form[name='"+this.listName+"'] .hxlistrow td:nth-child("+(hx.cint(idx)+hx.cint(colRowDelta))+")");
                rowCell.addClass('toggleMultilineClosed');  //Zoom-in Icon in allen Zellen der Spalte

                rowCell.on('click', (event) => { //Click Event registrieren
                    if (window.getSelection().toString().length == 0){ // zuklappen, nur wenn keine Markierung besteht (Copy und Paste Support)
                        this.colToggleMultiline(idx, colRowDelta, colHeadDelta, event.currentTarget);
                    }
                });
            }
        });

        //ListSetting-Overlays: Ausserhalb klicken - dieses schliessen
        $(document).on("click", (event) => {
            $("form[name='"+this.listName+"'] .js-hx_listsettings").hide();
        });

        //ListSetting-Overlay: Schliessen verhindern beim Anklicken
        $("form[name='"+this.listName+"'] .js-hx_listsettings").on("click", (event) => {
            event.stopPropagation();
        });

        //Listsetting-Overlay: Zahnrad-Icon anklicken - Overlay oeffnen/schliessen
        $("form[name='"+this.listName+"'] .js-hx_listsettings_toggler").on("click", (event) => {
            event.stopPropagation(); //stop bubbling to body
            event.preventDefault();
            let $hxListsettings = $("form[name='"+this.listName+"'] .js-hx_listsettings");

            $hxListsettings.toggle(); //show/hide Overlay

            //Ist Listentabelle weniger hoch als das Settings-Overlay, dann Overlay nach unten oeffnen
            if ($(".hxlist."+this.listName).height() < $hxListsettings.height() + 100) {
                $hxListsettings.addClass("listsettings-down")
            } else {
                $hxListsettings.removeClass("listsettings-down")
            }
        });

        //Listsetting-Overlay: Spaltensortierung via Drag&Drop ermoeglichen
        $("form[name='"+this.listName+"'] .listsettings_ul").sortable().disableSelection(); //JQery UI

        //Auf Touchgeraeten gibt es kein Mouseover: nofilter-Button zeigt beim
        //ersten Touch den filter-Button an, fuehrt dann die eigentliche Aktion aus
        //In Safari und Edge ist overflow=visible bereits Eventausfuehrung, bei Chrome noch nicht
        $("form[name='"+this.listName+"'] div.listcellfilterbtnbox span").on("touchstart", () => {
            if (!$("form[name='"+this.listName+"'] .listbtn_filter").is(":visible") && $("form[name='"+this.listName+"'] .listbtn_phonefilter").length===0) {
                $("form[name='"+this.listName+"'] .listbtn_filter").css("left", "18px").css('display','inline-flex');
                return false;
            } else {
                return true;
            }
        });

        //Spaltenbreite aendern: via JQueryUI aktivieren
        $("form[name='"+this.listName+"'] .hxlist_colresize.active").resizable({
            handles:'e' //nur nach rechtes resizable machen
        });

        //Spaltenbreite aendern
        $listForm.on("resize", ".hxlist_colresize.active", (event) =>{
            clearTimeout(this.colResizeTimeOutId);
            this.colResizeTimeOutId = setTimeout(() => {this.filterResizeSave(event.currentTarget)}, 500);
        });

        //Spaltenbreite aendern: Bei Doppelklick auf doppelte oder Ursprungsbreite springen
        $listForm.on("dblclick", ".ui-resizable-handle", (event) => {
            var $parentBox = $(event.currentTarget).parent(".hxlist_colresize.active");
            if ($parentBox.length>0) {
                var withCurrent = $parentBox.css("width");
                var withMin = $parentBox.css("min-width");
                var width = withMin; //Default: Breite auf Mindestbreite setzen
                if (withCurrent === withMin) width = (hx.cint(withCurrent)*2)+"px"; //Breite verdoppeln
                $parentBox.css("width",width);
                this.filterResizeSave($parentBox[0]); //[0] ... = native DOM Element (non JQuery Element)
            }
        });

    }

}
